export function useTurnstile() {
  const token = ref<string | null>()
  async function validateTurnstileToken() {
    if (!token.value) {
      throw new Error('Turnstile token is missing')
    }
    const response = await $fetch('/api/validateTurnstile', {
      method: 'POST',
      body: { token: token.value },
    })
    if (!response.success) {
      throw new Error('Turnstile verification failed')
    }
  }
  return {
    validateTurnstileToken,
    token,
  }
}
